import React from 'react';
import Header from '../components/Common/Header';
import './LegalPages.css';

const Disclaimer = () => {
  return (
    <>
      <Header />
      <div className="legal-page">
        <div className="legal-container">
          <h1>Disclaimer</h1>

          <section className="legal-section">
            <h2>1. General Information</h2>
            <p>
              The information provided by Bihar Election ("we," "us," or "our") on the Bihar Election Tracker application 
              is for general informational purposes only. All information on the Service is provided in good faith; however, 
              we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, 
              validity, reliability, availability, or completeness of any information on the Service.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Not an Official Government Service</h2>
            <p className="highlight-warning">
              <strong>IMPORTANT:</strong> Bihar Election Tracker is a PRIVATE information platform and is NOT affiliated with, 
              endorsed by, or connected to any government organization, election commission, or official electoral body. 
              We are an independent, privately-operated service.
            </p>
            <p>
              For official election information, please visit the official website of the Election Commission of India or 
              the State Election Commission of Bihar.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Information Accuracy</h2>
            <p>
              While we strive to provide accurate and up-to-date information, we cannot guarantee the completeness, accuracy, 
              or timeliness of:
            </p>
            <ul>
              <li>Election results and vote counting data</li>
              <li>Candidate information and profiles</li>
              <li>Poll percentages and voter turnout statistics</li>
              <li>News articles and updates</li>
              <li>Survey and opinion poll results</li>
            </ul>
            <p>
              Information displayed on our platform may contain errors, omissions, or be out of date. Users should verify 
              critical information through official sources.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. No Professional Advice</h2>
            <p>
              The content on this Service does not constitute professional advice (legal, political, financial, or otherwise). 
              Users should consult with qualified professionals before making decisions based on information from this Service.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Third-Party Content</h2>
            <p>
              Our Service may display content, including news articles, images, videos, and data, from third-party sources. 
              We do not control, verify, or endorse such content. Third-party content is provided for informational purposes 
              only and does not reflect our opinions or views.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Survey and Poll Results</h2>
            <p>
              Survey and opinion poll results displayed on our platform are based on user participation and may not represent 
              the actual voting intentions or outcomes of elections. These results should be interpreted as informal indicators 
              only and not as scientific or statistically valid predictions.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. External Links</h2>
            <p>
              Our Service may contain links to external websites that are not controlled or maintained by us. We have no 
              control over the nature, content, and availability of those sites. The inclusion of any links does not imply 
              a recommendation or endorsement of the views expressed within them.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Limitation of Liability</h2>
            <p>
              Under no circumstances shall Bihar Election, its owners, employees, or affiliates be liable for any:
            </p>
            <ul>
              <li>Direct, indirect, incidental, or consequential damages</li>
              <li>Loss of data or profits arising from use of the Service</li>
              <li>Errors or omissions in the content</li>
              <li>Decisions made based on information from the Service</li>
              <li>Technical failures or interruptions of the Service</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. No Warranty</h2>
            <p>
              THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. We disclaim all warranties, express or implied, 
              including but not limited to:
            </p>
            <ul>
              <li>Warranties of merchantability</li>
              <li>Fitness for a particular purpose</li>
              <li>Non-infringement</li>
              <li>Accuracy or reliability of information</li>
              <li>Uninterrupted or error-free operation</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>10. User Responsibility</h2>
            <p>
              Users are solely responsible for:
            </p>
            <ul>
              <li>Verifying information before relying on it</li>
              <li>Evaluating the accuracy and completeness of any content</li>
              <li>Consulting official sources for critical decisions</li>
              <li>Understanding that displayed data may be delayed or incomplete</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>11. Copyright and Intellectual Property</h2>
            <p>
              All original content on this Service is the property of Bihar Election or its content suppliers and is 
              protected by copyright laws. Candidate photos, party logos, and other materials may be owned by respective 
              individuals or organizations.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Changes to Service</h2>
            <p>
              We reserve the right to modify, suspend, or discontinue any aspect of the Service at any time without notice 
              or liability. We may also change this Disclaimer at any time by posting the updated version on this page.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Jurisdiction</h2>
            <p>
              This Disclaimer is governed by the laws of India. Any disputes arising from the use of this Service shall be 
              subject to the exclusive jurisdiction of the courts in Patna, Bihar.
            </p>
          </section>

          <section className="legal-section">
            <h2>14. Contact Information</h2>
            <p>
              If you have any questions about this Disclaimer, please contact us:
            </p>
            <ul>
              <li>Email: contact@bihar.com.co</li>
              <li>Phone: +91 7482909107</li>
              <li>Address: Patna, Bihar 800001, India</li>
            </ul>
          </section>

          <section className="legal-section disclaimer-footer">
            <p>
              <strong>By using this Service, you acknowledge that you have read, understood, and agree to be bound by 
              this Disclaimer.</strong>
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default Disclaimer;
